import React, { useState, useEffect, useRef, useCallback } from "react";
import toast from "react-hot-toast";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useNavigate } from "react-router-dom";
import isEqual from 'lodash/isEqual';

//Redux
import { useSelector, useDispatch } from "react-redux";

import { RFQChatHistory } from "../../../../Components/ChatBox/RFQChatBox";

// import {RFQChatHistory} from "../../"

//Serivce
import ItemService from "../../../../services/supplier_appCommonService";


//Components
import Layout from "../../../../Layout/Layout";
import { InputField } from "../../../../Components/formElements/InputField";
import { ComboboxField } from "../../../../Components/formElements/ComboboxField";
// import SourcingCommonFilter from "../../../Components/Filter/Sourcing/SourcingCommonFilter";
import PageLevelRiverseTimer from "../../../../Components/PageLevelRiverseTimer";
import DataTable from "react-data-table-component";
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";
import CommonItemLevelDatatableModal from "../../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";
import { formatDateTime } from "../../../../common/Validations";
import {
  createQuotation,
  getRfqQuotation,
} from "../../../../redux/feature/supplier_app/sourcingSlice";
// import { Card } from "react-bootstrap";
import Loader from "../../../../Components/Loader";
import RichTextEditor from "../../../../Components/Editor/RichTextEditor";
import Constants from "../../../../common/SupplierConstants";
import moment from "moment-timezone";
import FileViewerModal from "../../../../Components/FileViewer/FileViewerModal";

const VendorRFQDetails = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  localStorage.setItem("menu", "Sourcing");
  localStorage.setItem("submenu", "Request for Quotation");

  let rfxNr = useSelector((state) => state?.sourcing?.rfq?.rfxNr); // User Details from Store
  let userData = useSelector((state) => state?.user?.data);

  const [data, setData] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [hideButtons, setHideButtons] = useState(false);
  const [timerStatus, setTimerStatus] = useState(false);
  const [finalTimerValue, setFinalTimerValue] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });
  // View attachment files
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);

  const [isCardVisible1, setCardVisible1] = useState(true);
  const [isCardVisible2, setCardVisible2] = useState(true);
  const [isCardVisible3, setCardVisible3] = useState(true);
  const [isCardVisible4, setCardVisible4] = useState(true);
  const [isCardVisible5, setCardVisible5] = useState(true);
  const [isCardVisible8, setCardVisible8] = useState(true);
  const [isCardVisible9, setCardVisible9] = useState(true);
  const [isCardVisible10, setCardVisible10] = useState(true);
  const [isCardVisibleCS, setCardVisibleCS] = useState(true);

  const [formInputs, setFormInputs] = useState({
    rfxNr: "",
    rfxType: "",
    productType: "",
    rfxValue: "",
    rfxHeaderStatus: "",
    rfxbidType: "",
    rfxNoOfEvaluationType: "",
    rfxCurrency: "",
    rfxTechFocalPersonId: "",
    technicalApprovalType: "",
    plant: "",
    buyerResponsible: "",
    companyAddress: "",
    rfxVersion: "",
    buyerEmail: "",
    initiatorName: "",
    initiator: "",
    billingAddressCodeDesc: "",
    createdOn: "",
    buyerConact: "",
    deliveryAddressCodeDesc: "",
    rfxCategoryType: "",
    rfxCategoryCode: "",
    rfxCategoryDesc: "",
    rfqCreation: "",
    rfxTitle: "",
    openingdate: "",
    openingtime: "",
    closingdate: "",
    closingtime: "",
    rfxDescription: "",
    typeOfPurchase: "",
    otherCurrencies: "",
    headerIncoTerms: "",
    incoTermsLocation: "",
    procurementStrategies: "",
    items: "",
    formCOMM: "",
    formTECH: "",
    termsConditions: [],
    supplierList: [],

    openingDateTime: "",
    closingDateTime: "",
    totalHour: "",
  });

  // ========== DRAFT STATE ==========
  const [draftData, setDraftData] = useState(null);
  const [isLoadingDraft, setIsLoadingDraft] = useState(true);
  const previousFormInputsRef = useRef(null);
  const isFirstAutoSave = useRef(true);
  const draftDataRef = useRef(null);

  const isUpdatingRef = useRef(false); // ADD THIS
  const autoSaveTimerRef = useRef(null); // ADD THIs

  const DRAFT_DOCUMENT_TYPE = "VENDOR_RFQ"; // adjust as per backend

  // Local copies of questionnaire forms (with answer field)
  const [localFormDataCOMM, setLocalFormDataCOMM] = useState([]);
  const [localFormDataTECH, setLocalFormDataTECH] = useState([]);

  const toggleCardVisibility1 = () => {
    setCardVisible1(!isCardVisible1);
  };
  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };
  const toggleCardVisibility3 = () => {
    setCardVisible3(!isCardVisible3);
  };
  const toggleCardVisibility4 = () => {
    setCardVisible4(!isCardVisible4);
  };
  const toggleCardVisibility5 = () => {
    setCardVisible5(!isCardVisible5);
  };
  const toggleCardVisibility8 = () => {
    setCardVisible8(!isCardVisible8);
  };
  const toggleCardVisibility9 = () => {
    setCardVisible9(!isCardVisible9);
  };
  const toggleCardVisibility10 = () => {
    setCardVisible10(!isCardVisible10);
  };
  const toggleCardVisibilityCS = () => {
    setCardVisibleCS(!isCardVisibleCS);
  };

  const onInputChange = ({ target: { name, value } }) => {
    setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
  };

  /*  PRLineItem*/
  let PRLineItemInitialCol = [
    {
      name: "Document Item Nr",
      selector: (row) => row.local_id || "--",
      sortable: true,
      width: "180px",
    },
    {
      name: "Item Text",
      selector: (row) => row.local_id || "--",
      sortable: true,
      width: "110px",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() => lineItemShowModal(row.itemTextData)}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon">
            {" "}
            {row.itemTextData?.length || 0}{" "}
          </span>
        </>
      ),
    },
    {
      name: "Material/Service ",
      selector: (row) => row.materialCode || "--",
      sortable: true,
      width: "200px",
    },
    {
      name: "Description",
      selector: (row) => row.materialDescription || "--",
      sortable: true,
      width: "200px",
    },
    {
      name: "Material Group ",
      selector: (row) => row.materialGroup || "--",
      sortable: true,
      width: "200px",
    },
    {
      name: "Quantity ",
      selector: (row) => row.purchaseQuantity || "--",
      sortable: true,
      width: "200px",
    },
    {
      name: "UOM ",
      selector: (row) => row.orderUnitOfMeasure || "--",
      width: "200px",
    },
    {
      name: "Delivery Date",
      selector: (row) => row.deliveryDate || "--",
      width: "200px",
    },
    {
      name: "Plant",
      selector: (row) => row.plant || "--",
      sortable: true,
      width: "200px",
    },
    {
      name: "Storage Location",
      selector: (row) => row.storageLocn || "--",
      sortable: true,
      width: "200px",
    },
    {
      name: "Delete",
      selector: (row) => row.local_id || "--",
      width: "120px",
    },
  ];

  const loadInitialPageData = async () => {
    setLoading(true);
    if (rfxNr) {
      let obj = {
        documentNumber: rfxNr,
      };
      const toastId = toast.loading("Loading...", {
        position: "top-right",
      });
      await ItemService.getRfxDocumentDetail(obj).then((item) => {
        // console.log(">> res!", item);

        if (item?.status === 200) {
          setFormInputs(item.data);
          setData(item?.data?.items);

          updateTimerValue(item?.data?.closingDateTime);
          console.log("totalHour from API:", item?.data?.totalHour, "closingDateTime:", item?.data?.closingDateTime);

          if (
            item.data?.supplierList[0]?.rfxSupplierStatus === "Acknowledged" ||
            item.data?.supplierList[0]?.rfxSupplierStatus === "Regret"
          ) {
            setHideButtons(true);
          } else {
            setHideButtons(false);
          }
        } else {
          toast.error(item?.message || "Please try again !!", {
            duration: 4000,
            position: "top-right",
          });
        }
        toast.dismiss(toastId);
      });

      setLoading(false);
    } else {
      window.history.back();
    }
  };

  const updateTimerValue = (closingDateTime) => {
    let timerData = {};
    const openingMoment = moment(); // This is the current date-time
    const closingMoment = moment.tz(closingDateTime, "YYYY-MM-DD HH:mm", "Asia/Kolkata");
    const diffInMilliseconds = closingMoment.diff(openingMoment);

    // If the time is already past, return 0 and set timeExpired flag
    if (diffInMilliseconds <= 0) {
      setFinalTimerValue({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
      });
      setTimerStatus(true);
      return false;
    }

    const duration = moment.duration(diffInMilliseconds);
    setTimerStatus(false);
    // Extract days, hours, minutes, and seconds correctly
    timerData.days = Math.floor(duration.asDays()) || 0;
    timerData.hours = duration.hours() || 0; // Remaining hours after days
    timerData.minutes = duration.minutes() || 0; // Remaining minutes after hours
    timerData.seconds = duration.seconds() || 0; // Remaining seconds after minutes
    setFinalTimerValue(timerData);
    return true;
  };

  // PO items columns Details

  const lineItemColInfo = [
    {
      name: "Code",
      cell: (row) => <span>{row.documentId} </span>,
      width: "200px",
    },
    {
      name: "Text",
      cell: (row) => <span>{row.documentText} </span>,
      width: "250px",
    },
  ];

  // Show Item level data
  const [getItemLevelData, setItemLevelData] = useState([]);
  const [getItemLevelColumns, setItemLevelColumns] = useState([]);
  const [getModalTitle, setModalTitle] = useState("");
  const [itemLevelModalShow, setItemLevelModalShow] = useState(false);

  // OnClick on lineItem  Data
  const lineItemShowModal = (itemLevelData) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(lineItemColInfo);
    setModalTitle("Item Text Details");
    setItemLevelModalShow(true);
  };
  const itemLevelHideModal = () => {
    setItemLevelModalShow(false);
  };

  useEffect(() => {
    loadInitialPageData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rfxNr]);

  // Render Questions
  // const RenderInputField = ({ questionData }) => {
  //   const { componentId, mandatory, question, answerDefinition, serialNo } =
  //     questionData;

  //   switch (answerDefinition?.type) {
  //     case "textarea":
  //       return (
  //         <Col xs={12} md={6} lg={6} className="commLeftRightPadding">
  //           <TextAreaField
  //             label={serialNo + ". " + question?.label}
  //             id={componentId}
  //             name={componentId}
  //             className="inputBox"
  //             placeholder=""
  //             // value={getRemarks}
  //             // onChange={handleInputChange}
  //             required={mandatory}
  //           />
  //         </Col>
  //       );
  //     case "select":
  //       return (
  //         <Col xs={12} md={6} lg={6} className="commTopButtonRightLeftPadding">
  //           <ComboboxField
  //             label={serialNo + ". " + question?.label}
  //             placeholder=""
  //             data={answerDefinition?.options}
  //             id={componentId}
  //             iconClassName="dropdownIcon"
  //             name={componentId}
  //             code={componentId}
  //             required={mandatory}
  //           // setValue={formData.type || ""}
  //           // getvalue={setDropdownData}
  //           />
  //         </Col>
  //       );
  //     case "radio":
  //       return (
  //         <Col xs={12} md={6} lg={6} className="commTopButtonRightLeftPadding">
  //           <label className="block text-sm font-medium leading-6 text-gray-900 infoIconAccordion w-100">
  //             {serialNo + ". " + question?.label} {mandatory && "*"}
  //           </label>

  //           {answerDefinition?.options.map((option, index) => {
  //             return (
  //               <div key={index} className="block">
  //                 <input
  //                   type="radio"
  //                   className="form-check-input fs-5 ml-3"
  //                   id={`${componentId}-${index}`}
  //                   name={componentId}
  //                   // value={option?.value}
  //                   required={mandatory}
  //                 />
  //                 <span className="ml-3">{option?.value} </span>
  //               </div>
  //             );
  //           })}
  //         </Col>
  //       );
  //     case "checkbox":
  //       return (
  //         <Col xs={12} md={6} lg={6} className="commTopButtonRightLeftPadding">
  //           <label className="block text-sm font-medium leading-6 text-gray-900 infoIconAccordion w-100">
  //             {serialNo + ". " + question?.label} {mandatory && "*"}
  //           </label>

  //           {answerDefinition?.options.map((option, index) => {
  //             return (
  //               <div key={index} className="block">
  //                 <input
  //                   type="checkbox"
  //                   className="form-check-input fs-5 ml-3"
  //                   id={`${componentId}-${index}`}
  //                   name={componentId}
  //                   // value={option?.value}
  //                   required={mandatory}
  //                 />
  //                 <span className="ml-3">{option?.value} </span>
  //               </div>
  //             );
  //           })}
  //         </Col>
  //       );
  //     case "text":
  //       return (
  //         <Col
  //           xs={12}
  //           md={6}
  //           lg={6}
  //           className="commTopButtonRightLeftPadding block"
  //         >
  //           <InputField
  //             label={serialNo + ". " + question?.label}
  //             type="text"
  //             className="inputBox"
  //             id={componentId}
  //             name={componentId}
  //             placeholder=""
  //             // value={option.value}
  //             // onChange={(e) =>
  //             //   handleOptionChange(index, e.target.value)
  //             // }
  //             required={mandatory}
  //           />
  //         </Col>
  //       );
  //     case "number":
  //       return (
  //         <Col
  //           xs={12}
  //           md={6}
  //           lg={6}
  //           className="commTopButtonRightLeftPadding block"
  //         >
  //           <InputField
  //             label={serialNo + ". " + question?.label}
  //             type="number"
  //             className="inputBox"
  //             id={componentId}
  //             name={componentId}
  //             placeholder=""
  //             // value={option.value}
  //             // onChange={(e) =>
  //             //   handleOptionChange(index, e.target.value)
  //             // }
  //             required={mandatory}
  //           />
  //         </Col>
  //       );
  //     default:
  //       return "";
  //   }
  // };


  const RenderInputField = ({ questionData }) => {
    const { componentId, mandatory, question, answerDefinition, serialNo } = questionData;
    const currentValue = questionData.answer ?? "";

    const handleChange = (value) => {
      handleAnswerChange(componentId, value);
    };

    switch (answerDefinition?.type) {
      case "textarea":
        return (
          <Col xs={12} md={6} lg={6} className="commLeftRightPadding">
            <TextAreaField
              label={serialNo + ". " + question?.label}
              id={componentId}
              name={componentId}
              className="inputBox"
              placeholder=""
              value={currentValue}
              onChange={(e) => handleChange(e.target.value)}
              required={mandatory}
            />
          </Col>
        );
      case "select":
        return (
          <Col xs={12} md={6} lg={6} className="commTopButtonRightLeftPadding">
            <ComboboxField
              label={serialNo + ". " + question?.label}
              placeholder=""
              data={answerDefinition?.options}
              id={componentId}
              iconClassName="dropdownIcon"
              name={componentId}
              code="value"
              description="name"
              required={mandatory}
              setValue={currentValue}
              getvalue={(selected) => handleChange(selected?.value ?? selected)}
            />
          </Col>
        );
      case "radio":
        return (
          <Col xs={12} md={6} lg={6} className="commTopButtonRightLeftPadding">
            <label className="block text-sm font-medium leading-6 text-gray-900 infoIconAccordion w-100">
              {serialNo + ". " + question?.label} {mandatory && "*"}
            </label>
            {answerDefinition?.options.map((option, index) => (
              <div key={index} className="block">
                <input
                  type="radio"
                  className="form-check-input fs-5 ml-3"
                  id={`${componentId}-${index}`}
                  name={componentId}
                  value={option?.value}
                  checked={currentValue === option?.value}
                  onChange={() => handleChange(option?.value)}
                  required={mandatory}
                />
                <span className="ml-3">{option?.value}</span>
              </div>
            ))}
          </Col>
        );
      case "checkbox": {
        const toggleCheckbox = (optionValue) => {
          const currentArray = currentValue ? currentValue.split(",") : [];
          const isChecked = currentArray.includes(optionValue);
          let newArray;
          if (isChecked) {
            newArray = currentArray.filter((v) => v !== optionValue);
          } else {
            newArray = [...currentArray, optionValue];
          }
          handleChange(newArray.join(","));
        };
        return (
          <Col xs={12} md={6} lg={6} className="commTopButtonRightLeftPadding">
            <label className="block text-sm font-medium leading-6 text-gray-900 infoIconAccordion w-100">
              {serialNo + ". " + question?.label} {mandatory && "*"}
            </label>
            {answerDefinition?.options.map((option, index) => {
              const isChecked = currentValue ? currentValue.split(",").includes(option?.value) : false;
              return (
                <div key={index} className="block">
                  <input
                    type="checkbox"
                    className="form-check-input fs-5 ml-3"
                    id={`${componentId}-${index}`}
                    name={componentId}
                    value={option?.value}
                    checked={isChecked}
                    onChange={() => toggleCheckbox(option?.value)}
                    required={mandatory}
                  />
                  <span className="ml-3">{option?.value}</span>
                </div>
              );
            })}
          </Col>
        );
      }
      case "text":
      case "number":
        return (
          <Col xs={12} md={6} lg={6} className="commTopButtonRightLeftPadding block">
            <InputField
              label={serialNo + ". " + question?.label}
              type={answerDefinition?.type === "number" ? "number" : "text"}
              className="inputBox"
              id={componentId}
              name={componentId}
              placeholder=""
              value={currentValue}
              onChange={(e) => handleChange(e.target.value)}
              required={mandatory}
            />
          </Col>
        );
      default:
        return null;
    }
  };

  // Onclick on Table Header Button
  const handleAcknowledgeClick = async (type) => {
    let obj = {
      rfxNr: formInputs.rfxNr,
      AssociateNumber: userData?.AssociateNumber,
      rfxSupplierStatus: type === "A" ? "Acknowledged" : "Regret",
      acceptTermsConditions: true,
    };
    setDisabled(true);

    await ItemService.rfxAcknowledgementOrRegret(obj).then((item) => {
      if (item?.status === 200) {
        toast.success(item?.message, {
          duration: 3000,
          position: "top-right",
        });

        dispatch(getRfqQuotation({}));
        loadInitialPageData();
      } else {
        // console.log("Acknowledged Not successfully");

        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }

      setDisabled(false);
    });
  };

  const createQuotationPage = (rfxNr) => {
    const stillHasTime = updateTimerValue(formInputs.closingDateTime);
    if (stillHasTime) {
      dispatch(createQuotation(rfxNr));
      navigate(Constants.SOURCING_CREATE_QUOTATION);
    }
  };

  // ========== DRAFT HELPER FUNCTIONS ==========
  const createEmptyFormInputs = () => ({
    ...formInputs,
    formCOMM: [],
    formTECH: [],
  });

  const mapDraftToFormInputs = (draftData) => {
    const empty = createEmptyFormInputs();
    return {
      ...empty,
      ...draftData,
      formCOMM: draftData.formCOMM || [],
      formTECH: draftData.formTECH || [],
    };
  };

  // const getCurrentFormData = () => ({
  //   ...formInputs,
  //   formCOMM: localFormDataCOMM,
  //   formTECH: localFormDataTECH,
  // });

  // const getChangedFields = (oldData, newData) => {
  //   if (!oldData) return {};
  //   const changes = {};
  //   Object.keys(newData).forEach((key) => {
  //     if (!isEqual(oldData[key], newData[key])) {
  //       changes[key] = newData[key];
  //     }
  //   });
  //   return changes;
  // };

  const getCurrentFormData = useCallback(() => ({
    ...formInputs,
    formCOMM: localFormDataCOMM,
    formTECH: localFormDataTECH,
  }), [formInputs, localFormDataCOMM, localFormDataTECH]);

  const getChangedFields = useCallback((oldData, newData) => {
    if (!oldData) return {};
    const changes = {};
    Object.keys(newData).forEach((key) => {
      if (!isEqual(oldData[key], newData[key])) {
        changes[key] = newData[key];
      }
    });
    return changes;
  }, []);


  // const updateDraft = async () => {
  //   if (!previousFormInputsRef.current) {
  //     console.warn("Skipping draft update: no baseline");
  //     return;
  //   } 
  //   const currentData = getCurrentFormData();
  //   const changedData = getChangedFields(previousFormInputsRef.current, currentData);
  //   if (Object.keys(changedData).length === 0) {
  //     console.log("No changes detected, skipping draft update.");
  //     return;
  //   }

  //   try {
  //     const response = await ItemService.updateDraft(
  //       draftData?.documentNumber,
  //       userData?.userId,
  //       draftData?.draft,
  //       changedData
  //     );
  //     if (response.status === 200) {
  //       previousFormInputsRef.current = JSON.parse(JSON.stringify(currentData));
  //     }
  //   } catch (error) {
  //     console.error("Update draft failed:", error);
  //   }
  // };

  // ========== HANDLE ANSWER CHANGE ==========

  const updateDraft = useCallback(async () => {
    if (!previousFormInputsRef.current || isUpdatingRef.current) {
      console.warn("Skipping draft update: no baseline or update in progress");
      return;
    }
    const currentData = getCurrentFormData();
    const changedData = getChangedFields(previousFormInputsRef.current, currentData);
    if (Object.keys(changedData).length === 0) {
      console.log("No changes detected, skipping draft update.");
      return;
    }
    try {
      const response = await ItemService.updateDraft(
        draftData?.documentNumber,
        userData?.userId,
        draftData?.draft,
        changedData
      );
      if (response.status === 200) {
        // Only update the ref, don't trigger state updates
        previousFormInputsRef.current = JSON.parse(JSON.stringify(currentData));
      }
    } catch (error) {
      console.error("Update draft failed:", error);
    }
  }, [draftData, userData, getCurrentFormData, getChangedFields]);

  const handleAnswerChange = (componentId, value) => {
    const commIndex = localFormDataCOMM.findIndex((q) => q.componentId === componentId);
    if (commIndex !== -1) {
      const updated = [...localFormDataCOMM];
      updated[commIndex] = { ...updated[commIndex], answer: value };
      setLocalFormDataCOMM(updated);
      return;
    }
    const techIndex = localFormDataTECH.findIndex((q) => q.componentId === componentId);
    if (techIndex !== -1) {
      const updated = [...localFormDataTECH];
      updated[techIndex] = { ...updated[techIndex], answer: value };
      setLocalFormDataTECH(updated);
      return;
    }
  };

  // ========== AUTO-SAVE EFFECT ==========
  // useEffect(() => {
  //   if (isFirstAutoSave.current) {
  //     isFirstAutoSave.current = false;
  //     previousFormInputsRef.current = JSON.parse(JSON.stringify(getCurrentFormData()));
  //     return;
  //   }

  //   if (!draftDataRef.current || !previousFormInputsRef.current) return;

  //   const currentData = getCurrentFormData();
  //   const hasDataChanged = JSON.stringify(previousFormInputsRef.current) !== JSON.stringify(currentData);
  //   if (!hasDataChanged) return;

  //   const timer = setTimeout(async () => {
  //     try {
  //       await updateDraft();
  //     } catch (error) {
  //       console.error(error);
  //     }
  //   }, 2000);

  //   return () => clearTimeout(timer);
  // }, [localFormDataCOMM, localFormDataTECH, formInputs]);

  useEffect(() => {
    if (isFirstAutoSave.current) {
      isFirstAutoSave.current = false;
      previousFormInputsRef.current = JSON.parse(JSON.stringify(getCurrentFormData()));
      return;
    }

    if (!draftDataRef.current || !previousFormInputsRef.current) return;

    // Use a ref to track if update is in progress
    if (isUpdatingRef.current) return;

    const currentData = getCurrentFormData();
    const hasDataChanged = JSON.stringify(previousFormInputsRef.current) !== JSON.stringify(currentData);
    if (!hasDataChanged) return;

    // Clear any existing timer
    if (autoSaveTimerRef.current) {
      clearTimeout(autoSaveTimerRef.current);
    }

    autoSaveTimerRef.current = setTimeout(async () => {
      try {
        isUpdatingRef.current = true;
        await updateDraft();
        isUpdatingRef.current = false;
      } catch (error) {
        console.error(error);
        isUpdatingRef.current = false;
      }
    }, 2000);

    return () => {
      if (autoSaveTimerRef.current) {
        clearTimeout(autoSaveTimerRef.current);
      }
    };
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localFormDataCOMM, localFormDataTECH, formInputs]);

  useEffect(() => {
    draftDataRef.current = draftData;
  }, [draftData]);

  const handleTextChange = (data) => {
    // console.log(">> data", data);
  };

  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };

  // ========== LOAD DRAFT ON MOUNT ==========
  // useEffect(() => {
  //   const loadDraft = async () => {
  //     setIsLoadingDraft(true);
  //     try {
  //       const res = await ItemService.getDraftInitial(
  //         userData?.userId,
  //         DRAFT_DOCUMENT_TYPE,
  //         { rfxNr: rfxNr, associateNumber: userData?.AssociateNumber }
  //       );
  //       if (res.success && res.exists && res.data) {
  //         const mappedData = mapDraftToFormInputs(res.data);
  //         previousFormInputsRef.current = JSON.parse(JSON.stringify(mappedData));
  //         setDraftData(res.data);
  //         if (mappedData.formCOMM && mappedData.formCOMM.length) {
  //           setLocalFormDataCOMM(mappedData.formCOMM);
  //         }
  //         if (mappedData.formTECH && mappedData.formTECH.length) {
  //           setLocalFormDataTECH(mappedData.formTECH);
  //         }
  //       } else if (res.success && !res.exists) {
  //         const currentData = getCurrentFormData();
  //         const response = await ItemService.createDraft(
  //           userData?.userId,
  //           DRAFT_DOCUMENT_TYPE,
  //           { rfxNr: rfxNr, associateNumber: userData?.AssociateNumber }
  //         );
  //         if (response.success && response.data) {
  //           setDraftData(response.data);
  //           previousFormInputsRef.current = JSON.parse(JSON.stringify(currentData));
  //         }
  //       }
  //     } catch (error) {
  //       console.error("getDraftInitial API Error:", error);
  //     } finally {
  //       setIsLoadingDraft(false);
  //     }
  //   };
  //   if (userData?.userId && rfxNr) {
  //     loadDraft();
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [userData?.userId, rfxNr]);

  useEffect(() => {
    let isMounted = true;

    const loadDraft = async () => {
      setIsLoadingDraft(true);
      try {
        const res = await ItemService.getDraftInitial(
          userData?.userId,
          DRAFT_DOCUMENT_TYPE,
          { rfxNr: rfxNr, associateNumber: userData?.AssociateNumber }
        );

        if (!isMounted) return;

        if (res.success && res.exists && res.data) {
          const mappedData = mapDraftToFormInputs(res.data);
          previousFormInputsRef.current = JSON.parse(JSON.stringify(mappedData));
          setDraftData(res.data);
          if (mappedData.formCOMM && mappedData.formCOMM.length) {
            setLocalFormDataCOMM(mappedData.formCOMM);
          }
          if (mappedData.formTECH && mappedData.formTECH.length) {
            setLocalFormDataTECH(mappedData.formTECH);
          }
        } else if (res.success && !res.exists) {
          const currentData = getCurrentFormData();
          const response = await ItemService.createDraft(
            userData?.userId,
            DRAFT_DOCUMENT_TYPE,
            { rfxNr: rfxNr, associateNumber: userData?.AssociateNumber }
          );

          if (!isMounted) return;

          if (response.success && response.data) {
            setDraftData(response.data);
            previousFormInputsRef.current = JSON.parse(JSON.stringify(currentData));
          }
        }
      } catch (error) {
        console.error("getDraftInitial API Error:", error);
      } finally {
        if (isMounted) {
          setIsLoadingDraft(false);
        }
      }
    };

    if (userData?.userId && rfxNr) {
      loadDraft();
    }

    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData?.userId, rfxNr]); // Keep dependencies minimal

  useEffect(() => {
    console.log("Vendor RFQ Details: ", userData)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  // ========== INITIALIZE LOCAL FORMS FROM RFQ DATA ==========
  useEffect(() => {
    console.log('Initialisation effect running');
    if (formInputs.formCOMM && formInputs.formCOMM.length) {
      setLocalFormDataCOMM((prev) => {
        if (prev.length === 0) {
          return formInputs.formCOMM.map((q) => ({ ...q, answer: "" }));
        }
        const updated = formInputs.formCOMM.map((q) => {
          const existing = prev.find((p) => p.componentId === q.componentId);
          return existing ? { ...q, answer: existing.answer } : { ...q, answer: "" };
        });
        return updated;
      });
    }
    if (formInputs.formTECH && formInputs.formTECH.length) {
      setLocalFormDataTECH((prev) => {
        if (prev.length === 0) {
          return formInputs.formTECH.map((q) => ({ ...q, answer: "" }));
        }
        const updated = formInputs.formTECH.map((q) => {
          const existing = prev.find((p) => p.componentId === q.componentId);
          return existing ? { ...q, answer: existing.answer } : { ...q, answer: "" };
        });
        return updated;
      });
    }
  }, [formInputs.formCOMM, formInputs.formTECH]);

  if (isLoadingDraft) {
    return (
      <main className="dashboard main" id="main">
        <Layout />
        <Row className="justify-center subContent">
          <Col xs={12} md={12} className="rightSide">
            <div className="text-center mt-5">Loading draft...</div>
          </Col>
        </Row>
      </main>
    );
  }

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <Loader isLoading={loading} className={"text-center"} />
        </Col>

        {!loading && (
          <Col xs={12} md={12} className="rightSide">
            <div className="rightSideInner PageCommonCSS">
              <h2 className="mainTitle">
                Vendor RFQ
                <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
                  {formInputs?.rfxNr}
                </span>
                <span>
                  {formInputs?.supplierList[0]?.qtnSupplierStatus ===
                    "Published" ? (
                    <span className="bg-table-status bg-table-success-status headerStatusDetailedPage">
                      {formInputs?.supplierList[0]?.qtnSupplierStatus}
                    </span>
                  ) : formInputs?.supplierList[0]?.qtnSupplierStatus ===
                    "QTN Received" ? (
                    <span className="bg-table-status bg-table-progress-status headerStatusDetailedPage">
                      {formInputs?.supplierList[0]?.qtnSupplierStatus}
                    </span>
                  ) : formInputs?.supplierList[0]?.qtnSupplierStatus ===
                    "Cancelled" ? (
                    <span className="bg-table-status bg-table-danger-status headerStatusDetailedPage">
                      {formInputs?.supplierList[0]?.qtnSupplierStatus}
                    </span>
                  ) : formInputs?.supplierList[0]?.qtnSupplierStatus ===
                    "RFQ Created" ? (
                    <span className="bg-table-status bg-table-new-status headerStatusDetailedPage">
                      {formInputs?.supplierList[0]?.qtnSupplierStatus}
                    </span>
                  ) : formInputs?.supplierList[0]?.qtnSupplierStatus ===
                    "Acknowledged" ? (
                    <span className="bg-table-status bg-table-success-status headerStatusDetailedPage">
                      {formInputs?.supplierList[0]?.qtnSupplierStatus}
                    </span>
                  ) : (
                    formInputs?.supplierList[0]?.qtnSupplierStatus
                  )}
                </span>
                <span>
                  {formInputs?.supplierList[0]?.rfxSupplierStatus ===
                    "Regret" ? (
                    <span className="bg-table-status bg-table-danger-status headerStatusDetailedPage">
                      {formInputs?.supplierList[0]?.rfxSupplierStatus}
                    </span>
                  ) : formInputs?.supplierList[0]?.rfxSupplierStatus ===
                    "Acknowledged" ? (
                    <span className="bg-table-status bg-table-success-status headerStatusDetailedPage">
                      {formInputs?.supplierList[0]?.rfxSupplierStatus}
                    </span>
                  ) : (
                    formInputs?.supplierList[0]?.rfxSupplierStatus
                  )}
                </span>
              </h2>
              <p className="subText">Fill Vendor RFQ Details</p>
              <hr />

              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={12} md={5} lg={5} className="">
                        <p className="headerTitle fs-4">
                          Remaining Time for submission
                        </p>
                      </Col>
                      <Col xs={12} md={7} lg={7} className="flex justify-end">
                        <img
                          src="assets/img/stopwatch.png"
                          alt="stopwatch"
                          style={{ width: "60px", height: "58px" }}
                          className="mr-6 mt-1"
                        />
                        <PageLevelRiverseTimer timerData={finalTimerValue} />
                      </Col>
                    </Row>
                  </h2>
                </div>
              </div>

              {/*RFQ Type  */}
              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${isCardVisible1
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                            }`}
                          onClick={toggleCardVisibility1}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">RT</span>
                      </Col>
                      <Col xs={12} md={4} lg={4}>
                        <span className="headerTitle">RFQ Type </span>
                        <span className="subHeaderTitle">
                          RFQ Type Information
                        </span>
                      </Col>

                      <Col xs={12} md={6} lg={6} className="headerButtonAlign">
                        {!hideButtons && !timerStatus && (
                          <>
                            <Col xs={4} md={3} lg={3} className="">
                              <button
                                className="btnTable"
                                onClick={() => handleAcknowledgeClick("A")}
                                disabled={disabled}
                              >
                                <i className="bi bi-check2"></i> Acknowledge
                              </button>
                            </Col>
                            <Col xs={4} md={2} lg={2} className="">
                              <button
                                className="btnTable"
                                onClick={() => handleAcknowledgeClick("R")}
                                disabled={disabled}
                              >
                                <i className="bi bi-x-circle"></i> Regret
                              </button>
                            </Col>
                          </>
                        )}
                        {/* QTN Received */}
                        {formInputs?.supplierList[0]?.rfxSupplierStatus ===
                          "Acknowledged" &&
                          formInputs?.supplierList[0]?.qtnSupplierStatus !==
                          "QTN Received" &&
                          !timerStatus && (
                            <Col xs={4} md={3} lg={3} className="">
                              <button
                                className="btnTable"
                                onClick={() => {
                                  createQuotationPage(formInputs?.rfxNr);
                                }}
                              >
                                <i className="bi bi-clipboard-check"></i> Create
                                Quotation
                              </button>
                            </Col>
                          )}
                      </Col>
                    </Row>
                  </h2>

                  <div
                    className={`accordion-collapse collapse show ${isCardVisible1 ? "visible" : ""
                      }`}
                  >
                    <div className="accordion-body">
                      <Row className="pt-2 pb-4">
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="RFQ Category"
                            name="UnitPrice"
                            // placeholder=""
                            value={formInputs.rfxCategoryDesc || ""}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="RFQ Type"
                            name="UnitPrice"
                            // placeholder=""
                            value={formInputs.rfxTypeDesc || ""}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        {/* <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Header User id"
                            name="UnitPrice"
                            // placeholder=""
                            // value={PriceSheduleModuledata.UnitPrice || ""}

                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col> */}
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Number Of Evaluation"
                            name="UnitPrice"
                            // placeholder=""
                            value={formInputs.rfxNoOfEvaluationTypeDesc || ""}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Product Type"
                            name="firstName"
                            placeholder=""
                            value={formInputs.productTypeDesc || ""}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>

              {/*RFQ Type  -1*/}
              {/* <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${
                            isCardVisible2
                              ? "bi-chevron-right"
                              : "bi-chevron-down"
                          }`}
                          onClick={toggleCardVisibility2}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">RH</span>
                      </Col>
                      <Col xs={12} md={9} lg={9}>
                        <span className="headerTitle">RFQ Header </span>
                        <span className="subHeaderTitle">
                          RFQ Header Information
                        </span>
                      </Col>
                    </Row>
                  </h2>

                  <div
                    className={`accordion-collapse collapse show ${
                      isCardVisible2 ? "visible" : ""
                    }`}
                  >
                    <div className="accordion-body">
                      <Row className="pt-2 pb-4">
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="RFQ ID"
                            name="rfxNr"
                            // placeholder=""
                            value={formInputs.rfxNr || ""}
                            // onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Currency"
                            name="UnitPrice"
                            // placeholder=""
                            value={formInputs.rfxCurrencyCode || ""}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Buyer Contact"
                            name="UnitPrice"
                            // placeholder=""
                            value={formInputs.rfxCurrencyCode || ""}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Buyer Responsible"
                            name="UnitPrice"
                            // placeholder=""
                            value={formInputs.initiatorName || ""}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="RFQ Version"
                            name="firstName"
                            placeholder=""
                            value={formInputs.rfxVersion || ""}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Billing Address"
                            name="firstName"
                            placeholder=""
                            value={formInputs.billingAddressDesc || ""}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Company Address"
                            name="firstName"
                            placeholder=""
                            value={formInputs.companyAddressDesc || ""}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Delivery Address"
                            name="firstName"
                            placeholder=""
                            value={formInputs.companyAddressDesc || ""}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div> */}
              {/*RFQ Type  -2*/}
              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${isCardVisible2
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                            }`}
                          onClick={toggleCardVisibility2}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">RH</span>
                      </Col>
                      <Col xs={12} md={9} lg={9}>
                        <span className="headerTitle">RFQ Header </span>
                        <span className="subHeaderTitle">
                          RFQ Header Information
                        </span>
                      </Col>
                    </Row>
                  </h2>

                  <div
                    className={`accordion-collapse collapse show ${isCardVisible2 ? "visible" : ""
                      }`}
                  >
                    <div className="accordion-body">
                      <Row className="pt-2 pb-4">
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="RFQ ID"
                            name="rfxNr"
                            // placeholder=""
                            value={formInputs?.rfxNr || ""}
                            // onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Currency"
                            name="UnitPrice"
                            // placeholder=""
                            value={formInputs?.rfxCurrencyCode || ""}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Buyer Contact"
                            name="UnitPrice"
                            // placeholder=""
                            value={formInputs?.rfxCurrencyCode || ""}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Buyer Responsible"
                            name="UnitPrice"
                            // placeholder=""
                            value={formInputs?.initiatorName || ""}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="RFQ Version"
                            name="firstName"
                            placeholder=""
                            value={formInputs?.rfxVersion || ""}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Billing Address"
                            name="firstName"
                            placeholder=""
                            value={formInputs?.billingAddressDesc || ""}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Company Address"
                            name="firstName"
                            placeholder=""
                            value={formInputs?.companyAddressDesc || ""}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Delivery Address"
                            name="firstName"
                            placeholder=""
                            value={formInputs?.companyAddressDesc || ""}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={1}
                          lg={1}
                          className="commTopButtonRightLeftPadding  justify-content-center align-items-center"
                        >
                          <div className="d-flex flex-column ">
                            <p className="fw-medium m-0 text-nowrap">
                              Instructions Attachment
                            </p>

                            {(formInputs?.instructionsAttachment && (
                              <img
                                src="assets/img/newIcons/attached-file.png"
                                className="mt-1 attachmentIcon"
                                alt="attachments"
                                onClick={() =>
                                  handleViewFile(
                                    formInputs?.instructionsAttachment
                                  )
                                }
                              />
                            )) ||
                              "--"}
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>
              {/*Header Info-1 */}
              {/*  <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${
                            isCardVisible3
                              ? "bi-chevron-right"
                              : "bi-chevron-down"
                          }`}
                          onClick={toggleCardVisibility3}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">HI</span>
                      </Col>
                      <Col xs={12} md={9} lg={9}>
                        <span className="headerTitle">Header Info</span>
                        <span className="subHeaderTitle">
                          RFQ Header Information
                        </span>
                      </Col>
                    </Row>
                  </h2>

                  <div
                    className={`accordion-collapse collapse show ${
                      isCardVisible3 ? "visible" : ""
                    }`}
                  >
                    <div className="accordion-body">
                      <Row className="pt-2 pb-4">
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Title"
                            name="UnitPrice"
                            // placeholder=""
                            value={formInputs.rfxTitle || ""}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Description"
                            name="UnitPrice"
                            // placeholder=""
                            value={formInputs.rfxDescription || ""}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Opening Date/Time"
                            name="UnitPrice"
                            // placeholder=""
                            value={
                              formatDateTime(formInputs.openingDateTime) || ""
                            }
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Closing Date/Time"
                            name="UnitPrice"
                            // placeholder=""
                            value={
                              formatDateTime(formInputs.closingDateTime) || ""
                            }
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="INCOTerms"
                            name="firstName"
                            placeholder=""
                            value={formInputs.INCOTermslocation || ""}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="INCOTerms Location"
                            name="firstName"
                            placeholder=""
                            value={formInputs.INCOTermslocation || ""}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Payment Terms"
                            name="firstName"
                            placeholder=""
                            value={formInputs.paINCOTermslocation || ""}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Other Currencies"
                            name="firstName"
                            placeholder=""
                            // value={"400000 - Vasanthraman"}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                       
    
                      </Row>
                    </div>
                  </div>
                </div>
              </div> */}
              {/*Header Info-2 */}
              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${isCardVisible3
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                            }`}
                          onClick={toggleCardVisibility3}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">HI</span>
                      </Col>
                      <Col xs={12} md={9} lg={9}>
                        <span className="headerTitle">Header Info</span>
                        <span className="subHeaderTitle">
                          RFQ Header Information
                        </span>
                      </Col>
                    </Row>
                  </h2>

                  <div
                    className={`accordion-collapse collapse show ${isCardVisible3 ? "visible" : ""
                      }`}
                  >
                    <div className="accordion-body">
                      <Row className="pt-2 pb-4">
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Title"
                            name="UnitPrice"
                            // placeholder=""
                            value={formInputs?.rfxTitle || ""}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Description"
                            name="UnitPrice"
                            // placeholder=""
                            value={formInputs?.rfxDescription || ""}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Opening Date"
                            name="UnitPrice"
                            // placeholder=""
                            value={
                              formatDateTime(formInputs?.openingDateTime) || ""
                            }
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Closing Date"
                            name="UnitPrice"
                            // placeholder=""
                            value={
                              formatDateTime(formInputs?.closingDateTime) || ""
                            }
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="INCOTerms"
                            name="firstName"
                            placeholder=""
                            value={formInputs?.incoTermsLocation || ""}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="INCOTerms Location"
                            name="firstName"
                            placeholder=""
                            value={formInputs?.incoTermsLocation || ""}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Payment Terms"
                            name="firstName"
                            placeholder=""
                            // value={"400000 - Vasanthraman"}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Other Currencies"
                            name="firstName"
                            placeholder=""
                            value={formInputs?.otherCurrencies}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        {/* <Col
                                        xs={12}
                                        md={4}
                                        lg={4}
                                        className="commTopButtonRightLeftPadding"
                                      >
                                        <InputField
                                          className="inputBox"
                                          label="Milestone Payments"
                                          name="firstName"
                                          placeholder=""
                                          // value={"400000 - Vasanthraman"}
                                          onChange={onInputChange}
                                          disabled={true}
                                        />
                                      </Col> */}
                        {/* <Col
                                        xs={12}
                                        md={4}
                                        lg={4}
                                        className="commTopButtonRightLeftPadding"
                                      >
                                        <InputField
                                          className="inputBox"
                                          label="Instruction Attachments"
                                          name="firstName"
                                          placeholder=""
                                          // value={"400000 - Vasanthraman"}
                                          onChange={onInputChange}
                                          disabled={true}
                                        />
                                      </Col> */}
                      </Row>
                    </div>
                  </div>
                </div>
              </div>

              {/* Instructions 10*/}
              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${isCardVisible10
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                            }`}
                          onClick={toggleCardVisibility10}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">RE</span>
                      </Col>
                      <Col xs={8} md={9} lg={9}>
                        <span className="headerTitle">Instructions</span>
                        <span className="subHeaderTitle">
                          Instructions Section
                        </span>
                      </Col>
                    </Row>
                  </h2>

                  <div
                    className={`accordion-collapse collapse show ${isCardVisible10 ? "visible" : ""
                      }`}
                  >
                    <div className="accordion-body">
                      <Row className="p-4">
                        <Col xs={12} md={12} lg={12}>
                          <RichTextEditor
                            value={formInputs.instructions}
                            readOnly={true}
                            onChange={handleTextChange}
                          />
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>

              {/* Documents */}
              {/* <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${
                            isCardVisible4
                              ? "bi-chevron-right"
                              : "bi-chevron-down"
                          }`}
                          onClick={toggleCardVisibility4}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">TD</span>
                      </Col>
                      <Col xs={12} md={9} lg={9}>
                        <span className="headerTitle">Documents</span>
                        <span className="subHeaderTitle">
                          Documents Form 
                        </span>
                      </Col>
                    </Row>
                  </h2>

                  <div
                    className={`accordion-collapse collapse show ${
                      isCardVisible4 ? "visible" : ""
                    }`}
                  >
                    <div className="accordion-body">
                      <Row className="pt-2 pb-4">
                        <Col
                          xs={12}
                          md={12}
                          lg={12}
                          className="commTopButtonRightLeftPadding"
                        >
                          <h1 className="card-title">Documents :</h1>

                          <Attachments files={files} />
                          <h5 className="card-title"> Terms & Conditions</h5>
                          <Row>
                            <Col
                              xs={12}
                              md={12}
                              lg={8}
                              className="commTopButtonRightLeftPadding"
                            >
                              {formInputs.termsConditions.map((item, i) => (
                                <div className="form-check" key={item.id}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id={`gridCheck${item.id}`}
                                    checked={item.status}
                                    // onChange={() =>
                                    //   handleTermsConditionCheckBox(item.id)
                                    // }
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor={`gridCheck${item.id}`}
                                  >
                                    {item.name}
                                  </label>
                                </div>
                              ))}
                            </Col>
                            <Col xs={12} md={12} lg={3}>
                              <ComboboxField
                                label="Acceptance To Terms & Conditions"
                                placeholder=""
                                data={dropdownOption}
                                id=""
                                iconClassName="dropdownIcon"
                                name=""
                                // setValue={formInputs.INCOTermslocation || ""}
                                disabled={true}
                                // getvalue={setDropdownData}
                              />
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div> */}
              {/* Documents */}
              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${isCardVisible4
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                            }`}
                          onClick={toggleCardVisibility4}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">TD</span>
                      </Col>
                      <Col xs={12} md={9} lg={9}>
                        <span className="headerTitle">Documents</span>
                        <span className="subHeaderTitle">Documents Form</span>
                      </Col>
                    </Row>
                  </h2>

                  <div
                    className={`accordion-collapse collapse show ${isCardVisible4 ? "visible" : ""
                      }`}
                  >
                    <div className="accordion-body">
                      <h5 className="card-title"> Terms & Conditions</h5>
                      <Row className="pt-2 pb-4">
                        <Col
                          xs={12}
                          md={12}
                          lg={8}
                          className="commTopButtonRightLeftPadding"
                        >
                          {formInputs?.termsConditions.map((item, i) => (
                            <div className="form-check" key={item.id}>
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id={`gridCheck${item.id}`}
                                checked={item.status}
                              // onChange={() =>
                              //   handleTermsConditionCheckBox(item.id)
                              // }
                              />
                              <label
                                className="form-check-label"
                                htmlFor={`gridCheck${item.id}`}
                              >
                                {item.name}
                              </label>
                            </div>
                          ))}
                        </Col>
                        {/* <Col xs={12} md={12} lg={3}>
                                        <ComboboxField
                                          label="Acceptance To Terms & Conditions"
                                          placeholder=""
                                          data={dropdownOption}
                                          id=""
                                          iconClassName="dropdownIcon"
                                          name=""
                                          // setValue={formInputs.INCOTermslocation || ""}
                                          disabled={true}
                                          // getvalue={setDropdownData}
                                        />
                                      </Col> */}
                        <Row>
                          <h1 className="card-title">Documents :</h1>

                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <p className="fw-medium m-0">1.1. SCOPE OF WORK</p>
                            {(formInputs?.scopeOfwork && (
                              <img
                                src="assets/img/newIcons/attached-file.png"
                                className="mt-1 attachmentIcon"
                                alt="attachments"
                                onClick={() =>
                                  handleViewFile(formInputs?.scopeOfwork)
                                }
                              />
                            )) ||
                              "--"}
                          </Col>
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <p className="fw-medium m-0">1.2. DRAWING</p>
                            {(formInputs?.drawing && (
                              <img
                                src="assets/img/newIcons/attached-file.png"
                                className="mt-1 attachmentIcon"
                                alt="attachments"
                                onClick={() =>
                                  handleViewFile(formInputs?.drawing)
                                }
                              />
                            )) ||
                              "--"}
                          </Col>
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <p className="fw-medium m-0">1.3. ANNEXURES</p>
                            {(formInputs?.annexures && (
                              <img
                                src="assets/img/newIcons/attached-file.png"
                                className="mt-1 attachmentIcon"
                                alt="attachments"
                                onClick={() =>
                                  handleViewFile(formInputs?.annexures)
                                }
                              />
                            )) ||
                              "--"}
                          </Col>
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <p className="fw-medium m-0">1.4. OTHERS</p>
                            {(formInputs?.others && (
                              <img
                                src="assets/img/newIcons/attached-file.png"
                                className="mt-1 attachmentIcon"
                                alt="attachments"
                                onClick={() =>
                                  handleViewFile(formInputs?.others)
                                }
                              />
                            )) ||
                              "--"}
                          </Col>
                        </Row>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>

              {/*charges selection*/}
              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${isCardVisibleCS
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                            }`}
                          onClick={toggleCardVisibilityCS}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">CS</span>
                      </Col>
                      <Col xs={8} md={9} lg={9}>
                        <span className="headerTitle">Charges Selection</span>
                        <span className="subHeaderTitle">Charges Selection</span>
                      </Col>
                    </Row>
                  </h2>

                  <div
                    className={`accordion-collapse collapse show ${isCardVisibleCS ? "visible" : ""
                      }`}
                  >
                    <div className="accordion-body">
                      <Row className="pt-2 pb-4">
                        <h5 className="card-title commTopButtonRightLeftPadding">Select Charges</h5>
                        <Row>
                          <Col
                            xs={12}
                            md={12}
                            lg={8}
                            className="commTopButtonRightLeftPadding"
                          >
                            {formInputs?.othersCharge?.map((charge) => (
                              <div className="form-check" key={charge.id}>
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id={`charge-${charge.id}`}
                                  checked={formInputs?.othersCharge?.some(
                                    (item) => item.id === charge.id
                                  )}
                                // onChange={() => handleChargeToggle(charge)}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor={`charge-${charge.id}`}
                                >
                                  {charge.name}
                                </label>
                              </div>
                            ))}
                          </Col>
                        </Row>


                      </Row>
                    </div>
                  </div>
                </div>
              </div>

              {/* 5 */}
              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${isCardVisible5
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                            }`}
                          onClick={toggleCardVisibility5}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">LI</span>
                      </Col>
                      <Col xs={12} md={6} lg={7}>
                        <span className="headerTitle">Line Items</span>
                        <span className="subHeaderTitle">
                          Material/ Service Details
                        </span>
                      </Col>
                    </Row>
                  </h2>
                  <div
                    // id="acc"
                    className={`accordion-collapse collapse show ${isCardVisible5 ? "visible" : ""
                      }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      <Row>
                        <Col xs={12} md={12} lg={12}>
                          <DataTable
                            // title=""
                            columns={PRLineItemInitialCol}
                            data={data}
                            // progressPending={loading}
                            // paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                            // pagination
                            // paginationServer
                            // paginationTotalRows={totalRows}
                            // onChangeRowsPerPage={handlePerRowsChange}
                            // onChangePage={handlePageChange}
                            selectableRows
                          />
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>

              {/* COMM - Spares & Operation Maintenance 08*/}
              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${isCardVisible8
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                            }`}
                          onClick={toggleCardVisibility8}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">OC</span>
                      </Col>

                      <Col xs={4} md={8} lg={7}>
                        <span className="headerTitle">
                          Form: COMMERCIAL - Questionnaire
                        </span>
                        {/* <span className="subHeaderTitle">
                        Other Charges Table{" "}
                      </span> */}
                      </Col>
                    </Row>
                  </h2>

                  <div
                    // id="acc"
                    className={`accordion-collapse collapse show ${isCardVisible8 ? "visible" : ""
                      }`}
                  >
                    <div className="accordion-body">
                      <Row className="commTopButtonRightLeftPadding">
                        {/* {formInputs.formCOMM.length > 0 &&
                          formInputs.formCOMM.map((formJsonData, index) => {
                            return (
                              <RenderInputField
                                questionData={formJsonData}
                                key={index}
                              />
                            );
                          })} */}

                        {/* {formInputs.formCOMM.length > 0 &&
                          formInputs.formCOMM.map((formJsonData, index) => (
                            <RenderInputField questionData={formJsonData} key={index} />
                          ))} */}

                        {localFormDataCOMM.length > 0 &&
                          localFormDataCOMM.map((formJsonData, index) => (
                            <RenderInputField questionData={formJsonData} key={index} />
                          ))}
                        {localFormDataCOMM.length === 0 && (
                          <p className="text-center mt-4">No COMM questionnaire available.</p>
                        )}

                      </Row>
                    </div>
                  </div>
                </div>
              </div>

              {/* Form :TECH - Spares & Operation Maintenance09*/}
              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${isCardVisible9
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                            }`}
                          onClick={toggleCardVisibility9}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">TS</span>
                      </Col>

                      <Col xs={4} md={8} lg={7}>
                        <span className="headerTitle">
                          Form : TECHNICAL - Questionnaire
                        </span>
                      </Col>
                    </Row>
                  </h2>

                  <div
                    // id="acc"
                    className={`accordion-collapse collapse show ${isCardVisible9 ? "visible" : ""
                      }`}
                  >
                    <div className="accordion-body">
                      <Row className="commTopButtonRightLeftPadding">
                        {/* {formInputs.formTECH.length > 0 &&
                          formInputs.formTECH.map((formJsonData, index) => {
                            return (
                              <RenderInputField
                                questionData={formJsonData}
                                key={index}
                              />
                            );
                          })} */}

                        {localFormDataTECH.length > 0 &&
                          localFormDataTECH.map((formJsonData, index) => (
                            <RenderInputField questionData={formJsonData} key={index} />
                          ))}
                        {localFormDataTECH.length === 0 && (
                          <p className="text-center mt-4">No TECH questionnaire available.</p>
                        )}



                      </Row>
                    </div>
                  </div>
                </div>
              </div>


               <div className="accordion mb-4" id="chatHistoryAccordion">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i className="bi bi-chat-dots fs-4"></i>
                      </Col>
                      <Col xs={12} md={11} lg={11}>
                        <span className="headerTitle">Chat History</span>
                        <span className="subHeaderTitle">Conversation with Buyer</span>
                        
                      </Col>
                    </Row>
                  </h2>
                  <div className="accordion-collapse collapse show visible">
                    <div className="accordion-body">
                      <RFQChatHistory
                        key={`chat-${formInputs._id}`}
                        rfxId={formInputs._id}
                        suppliers={formInputs.supplierList || []}
                        buyer={formInputs?.buyerResponsible}
                        // suppliers={formInputs.supplierList}
                         hideDropdown={true} 
                      />
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </Col>
        )}
      </Row>

      {/* Item Text  */}
      <CommonItemLevelDatatableModal
        show={itemLevelModalShow}
        onHide={() => itemLevelHideModal()}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
      />
      <FileViewerModal
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
      />
    </main>
  );
};

export default VendorRFQDetails;
